'use client'
import { cn } from '@/shared/lib/classnames'
import { Breadcrumbs, BreadcrumbsItemType } from '@/shared/ui/breadcrumbs'
import { HTMLAttributes } from 'react'
import { NavigateBackIcon, NavigateBackIconProps } from '../navigation-back'
import { useRouter } from 'next/navigation'
import ShowMoreText from '../show-more/show-more-text.ui'

export interface Props extends HTMLAttributes<HTMLElement> {
  heading?: React.ReactNode
  headingSlot?: React.ReactNode
  breadcrumbs?: (BreadcrumbsItemType | null)[]
  navigateBack?: boolean
  navigateBackProps?: NavigateBackIconProps
  description?: React.ReactNode
}

export default function Component({
  className,
  heading,
  breadcrumbs,
  navigateBack,
  navigateBackProps,
  description,
  headingSlot,
  children,
}: Props) {
  const router = useRouter()
  return (
    <div className={cn('mb-[20px]', className)}>
      {breadcrumbs && (
        <div className="mb-5">
          <Breadcrumbs items={breadcrumbs.filter((breadcrumb) => breadcrumb != null) as BreadcrumbsItemType[]} />
        </div>
      )}
      <div className="flex items-center gap-3">
        {navigateBack && (
          <NavigateBackIcon
            onClick={router.back}
            {...navigateBackProps}
            className={cn('rounded-full p-2', navigateBackProps?.className || '')}
          />
        )}
        {headingSlot ? headingSlot : heading && <h1 className="text-[32px] font-medium">{heading}</h1>}
      </div>
      <div className="text-muted-foreground text-sm">
        {typeof description === 'string' && <ShowMoreText text={description} maxLength={70} />}
      </div>
    </div>
  )
}
